import React, {Component} from 'react';
import I18n from 'app/i18n';
import {articleHeading} from 'app/utils/ArticleHeading';
import {inject, observer} from 'mobx-react';
import {ArticlesStore} from 'app/store/ArticlesStore';
import {UserStore} from 'app/store/UserStore';
import PromoNew from 'app/components/pages/articles/PromoNew';
import PromoNewBanner from 'app/components/pages/articles/PromoNewBanner';
import PromoNewCard from 'app/components/pages/articles/PromoNewCard';
import PromoNewFilters from 'app/components/pages/articles/PromoNewFilters';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';
import {
    getFilteredAndSortedPromoNewItems,
    PROMO_NEW_FILTER_TABS,
    PROMO_NEW_SORT_OPTIONS,
    PromoNewFilterType,
    PromoNewSortType
} from 'app/utils/promoNewFilterUtils';

interface PromoNewProps {
    articlesStore?: ArticlesStore
    userStore?: UserStore
}

@inject('articlesStore', 'userStore')
@observer
export default class PromoNewPage extends Component<PromoNewProps> {
    state = {
        filterType: PROMO_NEW_FILTER_TABS[0],
        sortType: PROMO_NEW_SORT_OPTIONS[0]
    };

    constructor(props: PromoNewProps) {
        super(props);
        const {articlesStore, userStore} = props;
        const {experimental_features} = userStore?.user || {};

        if (experimental_features) {
            articlesStore.loadPromoPageIndex();
        } else {
            articlesStore.refreshPromoNew();
        }
    }

    handleFilterChange = (filterType: PromoNewFilterType): void => {
        this.setState({filterType});
    };

    handleSortChange = (sortType: PromoNewSortType): void => {
        this.setState({sortType});
    };

    render(): React.ReactNode {
        const {promoNewData: {loading, bets_promo, casino_promo, permanent_promo},
            promoNewIndexItems, promoNewIndexLoading,
            activePromoNewCount, participatedPromoCount, hideExpiredPromoNewIndexItem} = this.props.articlesStore;
        const {experimental_features} = this.props.userStore?.user || {};
        const isLoading = experimental_features ? promoNewIndexLoading : loading;
        const participatedCount = experimental_features
            ? promoNewIndexItems.filter(item => item.promo_bonus?.participation?.participating === true).length
            : participatedPromoCount;
        const {filterType, sortType} = this.state;
        const filteredPromotions = getFilteredAndSortedPromoNewItems(promoNewIndexItems, filterType, sortType);

        return isLoading
            ? <SmartFullPageLoader/>
            : <>
                {experimental_features
                    ? <PromoNewBanner activePromoNewCount={activePromoNewCount} participatedPromoCount={participatedCount}/>
                    : <div className="header-promo-articles">
                        <h1 className="name">{articleHeading('promotions')}</h1>
                        <div className="header-label">
                            <span className="label">
                                {I18n.t('promo_new_top_label', {count: activePromoNewCount})}
                            </span>
                        </div>
                    </div>
                }
                {experimental_features
                    ? <>
                        <PromoNewFilters
                            filterType={filterType}
                            sortType={sortType}
                            onFilterChange={this.handleFilterChange}
                            onSortChange={this.handleSortChange}
                        />
                        <div className="promo-new-grid">
                            <div className="promo-new-grid__list">
                                {filteredPromotions.length > 0
                                    ? filteredPromotions.map(article => <PromoNewCard
                                        key={article.id}
                                        data={article}
                                        hideExpiredPromoNewIndexItem={hideExpiredPromoNewIndexItem}
                                    />)
                                    : <p className="promo-new-grid__empty">{I18n.t('empty_results')}</p>}
                            </div>
                        </div>
                    </>
                    : <>
                        <PromoNew
                            articles={bets_promo}
                            svgNameIcon="svg-promo-topical"
                            header={I18n.t('promo_new_header_topical')}
                        />
                        <PromoNew
                            articles={casino_promo}
                            svgNameIcon="svg-promo-casino"
                            header={I18n.t('promo_new_header_casino')}
                        />
                        <PromoNew
                            articles={permanent_promo}
                            svgNameIcon="svg-promo-permanent"
                            header={I18n.t('promo_new_header_permanent')}
                        />
                    </>}
            </>;
    }
}
